import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SupplementCategories from './supplement-categories';
import SupplementCategoriesDetail from './supplement-categories-detail';
import SupplementCategoriesUpdate from './supplement-categories-update';
import SupplementCategoriesDeleteDialog from './supplement-categories-delete-dialog';

const SupplementCategoriesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SupplementCategories />} />
    <Route path="new" element={<SupplementCategoriesUpdate />} />
    <Route path=":id">
      <Route index element={<SupplementCategoriesDetail />} />
      <Route path="edit" element={<SupplementCategoriesUpdate />} />
      <Route path="delete" element={<SupplementCategoriesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SupplementCategoriesRoutes;
